import {
  ContactGroup,
  ContactType,
} from "../../../api/firebase/types/contact.types";
import { ContactOption } from "../../../api/firebase/types/scenario.types";
import { CheckboxColumnTemplate } from "../../templates/ChecboxColumnTemplate";

export const ContactOptionColumnTemplate = (
  contactOrGroup: ContactType | ContactGroup,
  contactOption: ContactOption,
  contactSettings: Map<ContactOption, string[]>,
  onChange: (contactSettings: Map<ContactOption, string[]>) => void
) => {
  const addEntry = () => {
    const updatedContactSettings = new Map(contactSettings);
    const existingEntries = updatedContactSettings.get(contactOption) || [];
    updatedContactSettings.set(contactOption, [
      ...existingEntries,
      contactOrGroup.id,
    ]);
    return updatedContactSettings;
  };

  const removeEntry = () => {
    const updatedContactSettings = new Map(contactSettings);
    if (!updatedContactSettings.has(contactOption))
      throw Error("The contact option does not exist");
    const existingEntries = updatedContactSettings.get(contactOption);
    const updatedEntries =
      existingEntries?.filter((entryId) => entryId !== contactOrGroup.id) || [];
    updatedContactSettings.set(contactOption, updatedEntries);
    return updatedContactSettings;
  };

  const onOptionChange = (checked: boolean) => {
    const updatedContactSettings = checked ? addEntry() : removeEntry();
    onChange(updatedContactSettings);
  };

  return (
    <CheckboxColumnTemplate
      checked={contactSettings.get(contactOption)?.includes(contactOrGroup.id)}
      onChange={onOptionChange}
    />
  );
};
